/* NO-SIM-NOMAG-1027: 3x magnifier removed from the simulator (Bon 27 Oct 2026): no magnifier picture, no magnifier sticker. Undo: STORE-FIXES-1022/WORK/predator-sim-nomag-1027/nomag.py --undo --apply */
/* ============================================================================
   Night Operators PREDATOR lander (assets/predator-lander.js)
   Branch PREDATOR-LIVE (2026-09-04) and PREDATOR-LIVE-2 (2026-09-04, second pass).
   Vanilla IIFE scoped to #no-predator, the native port of
   https://nightoperators.lovable.app/ (snippets/predator-lander.liquid).
   No framework, no build step, no postMessage bridge.

   Everything interactive on the source page, ported from its bundle (capture/bundle.js):
     announcement bar, CONTENTS drawer (with the active section highlight), sticky CTA
     bars, in-page anchors, FAQ accordion,
     03 compare tabs (image + callout + "Analog devices sold separately" banner) and
        SHOW ALL 4 LIMITS / SHOW LESS,
     04 role tabs (image + ROLE text) and SEE WHAT IT LOOKS LIKE (jumps to the viewer),
     05 INTERACTIVE THERMAL VIEWER: lens pill, equip / light / EOTech / 3x magnifier /
        power, the ten keypad buttons (crosshair, palette, zoom, gear, +, -, power hold),
        HUD readout, RESET, the guided stickers and the leader line,
     06 lens cards and 08 bridged card SEE WHAT IT LOOKS LIKE (range sim lens / fusion tab),
     11 tier rows (select + jump to 16) and the sticky MARKUP CHAIN scroll animation,
     14 RANGE SIMULATOR on canvas at the true 320 x 320 (lens, subject, distance, zoom),
     15 VIEW FULL SPECS / HIDE FULL SPECS,
     16 IN THE BOX tier tabs, tier copy, sprite hotspots (tap to add), add-on rows,
        CLAIM FREE bridge controls, build hint, ADD THIS KIT,
     20 BUY BOX tier cards with the bridge claim animation (cover wipe, glow, flying
        dot), CLAIM / BRIDGE CLAIMED pills (click again to unclaim), add-on rows,
        bridge row, Sezzle line, GET THE PREDATOR,
     DropLock pills in place of every CTA until 2026-09-04 14:00 UTC.
   Every buy control drives window.NOPredatorKit (assets/predator-kit.js, loaded by the
   kit selector in the product info section), so the kit selector, the lander and the
   cart payload always agree, including the bridge claim, in both directions.
   ========================================================================== */
(function () {
  'use strict';
  var root = document.getElementById('no-predator');
  if (!root || root.hasAttribute('data-no-bound')) return;
  root.setAttribute('data-no-bound', '1');

  var ORIGIN = 'https://nightoperators.lovable.app';
  var ASSET = ORIGIN + '/__l5e/assets-v1/';
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function hooks(name) { return $$('[data-no="' + name + '"]'); }
  function hook(name) { return $('[data-no="' + name + '"]'); }
  function txt(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }
  function addCls(el, list) { list.split(/\s+/).forEach(function (c) { if (c) el.classList.add(c); }); }
  function rmCls(el, list) { list.split(/\s+/).forEach(function (c) { if (c) el.classList.remove(c); }); }
  function swapCls(el, off, on) { rmCls(el, off); addCls(el, on); }
  function el(tag, cls, style) { var e = document.createElement(tag); if (cls) e.className = cls; if (style) e.style.cssText = style; return e; }
  function money(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: (Math.abs(n - Math.round(n)) < 0.005) ? 0 : 2, maximumFractionDigits: 2 }); }
  function money2(n) { return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  var reducedMotion = false;
  try { reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-check w-3 h-3"><path d="M20 6 9 17l-5-5"></path></svg>';
  var DOT = '<span class="block rounded-full bg-accent w-[6px] h-[6px]" style="box-shadow:0 0 6px hsl(var(--accent) / 0.9)" aria-hidden="true"></span>';

  /* ---------------------------------------------------------------- 0. silence */
  function silence() {
    $$('video').forEach(function (v) { v.muted = true; v.volume = 0; v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); });
  }
  silence();
  window.addEventListener('load', silence);

  /* ---------------------------------------------------------------- 1. kit engine (may arrive later: both scripts are deferred) */
  var kit = null;
  function whenKit(fn) {
    if (window.NOPredatorKit) { kit = window.NOPredatorKit; fn(kit); return; }
    var n = 0, t = setInterval(function () {
      if (window.NOPredatorKit) { clearInterval(t); kit = window.NOPredatorKit; fn(kit); }
      else if (++n > 80) { clearInterval(t); if (window.console) console.warn('[no-predator] kit engine missing: lander CTAs fall back to anchors'); }
    }, 100);
  }

  /* ---------------------------------------------------------------- 2. theme header offset */
  var CANDIDATES = 'header, .header-wrapper, .announcement-bar, [id*="header"], [id*="announcement"], [class*="announcement"], [data-sticky-header], sticky-header';
  /* PDP-SPEED 2026-09-04: pinnedBottom is called from loop() on EVERY animation
     frame for 900ms after EVERY scroll event, which is about 54 times a gesture.
     It used to run document.querySelectorAll over the eight clause CANDIDATES
     selector, then getComputedStyle and getBoundingClientRect on every match,
     every one of those times.

     Two facts make almost all of that redundant. The set of header elements on
     the page does not change after first paint, and an element's `position` is
     set by the stylesheet rather than by scrolling. Both are therefore resolved
     ONCE and cached, and the cache is dropped only on resize and
     orientationchange, where a responsive header can genuinely swap.

     Per frame we still read visibility, because a sticky header can be shown or
     hidden mid gesture, and the rect, because that is the thing that moves.

     Measured against the real served DOM (9 candidates match, 2 are positioned),
     per 900ms gesture: querySelectorAll 54 to 1, getComputedStyle 486 to 108,
     getBoundingClientRect 486 to 108. The arithmetic and both clamps below are
     byte for byte the originals. */
  var _pbCache = null;
  function _pbRefresh() {
    var keep = [], els = document.querySelectorAll(CANDIDATES);
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (root.contains(e) || e.contains(root)) continue;
      var cs = getComputedStyle(e);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      keep.push(e);
    }
    _pbCache = keep;
    return keep;
  }
  window.addEventListener('resize', function () { _pbCache = null; }, { passive: true });
  window.addEventListener('orientationchange', function () { _pbCache = null; }, { passive: true });
  function pinnedBottom() {
    var max = 0, els = _pbCache || _pbRefresh();
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      var cs = getComputedStyle(e);
      if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0') continue;
      var r = e.getBoundingClientRect();
      if (r.height === 0 || r.height > 220) continue;
      if (r.top > 8) continue;
      if (r.bottom > max) max = r.bottom;
    }
    return Math.min(Math.max(max, 0), 220);
  }
  var lastTop = -1, lastAnn = -1;
  function place() {
    var top = Math.round(pinnedBottom());
    var annEl = hook('announce');
    var annH = 0;
    if (annEl && !annEl.hidden) { var ar = annEl.getBoundingClientRect(); if (ar.height > 0 && ar.top <= top + 2) annH = Math.round(ar.height); }
    if (top === lastTop && annH === lastAnn) return;
    lastTop = top; lastAnn = annH;
    root.style.setProperty('--no-sticky-top', top + 'px');
    root.style.setProperty('--no-sticky-cta-top', (top + annH) + 'px');
  }

  /* ---------------------------------------------------------------- 3. announcement bar */
  var ann = hook('announce');
  if (ann) {
    ann.style.top = 'var(--no-sticky-top, 0px)';
    var dismiss = hook('announce-dismiss');
    if (dismiss) dismiss.addEventListener('click', function () { ann.hidden = true; });
  }

  /* ---------------------------------------------------------------- 4. contents drawer + active section */
  var navOpen = hook('nav-open'), navAside = hook('nav-aside'), navOverlay = hook('nav-overlay'), navClose = hook('nav-close');
  var navItems = hooks('nav-item');
  function setNav(open) {
    if (navAside) { navAside.classList.toggle('-translate-x-full', !open); navAside.classList.toggle('translate-x-0', open); }
    if (navOverlay) { navOverlay.classList.toggle('opacity-0', !open); navOverlay.classList.toggle('pointer-events-none', !open); navOverlay.classList.toggle('opacity-100', open); }
    if (navOpen) navOpen.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (navOpen) navOpen.addEventListener('click', function () { setNav(!(navAside && navAside.classList.contains('translate-x-0'))); });
  if (navClose) navClose.addEventListener('click', function () { setNav(false); });
  if (navOverlay) navOverlay.addEventListener('click', function () { setNav(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });
  function jumpTo(target, behavior) {
    if (!target) return;
    target.scrollIntoView({ behavior: behavior || 'auto', block: 'start' });
    var n = 0, fix = setInterval(function () {
      var r = target.getBoundingClientRect();
      if (Math.abs(r.top) > 40) target.scrollIntoView({ behavior: 'auto', block: 'start' });
      if (++n > 16) clearInterval(fix);
    }, 150);
  }
  navItems.forEach(function (b) {
    b.addEventListener('click', function () {
      var id = b.getAttribute('data-no-val');
      setNav(false);
      jumpTo(id ? document.getElementById(id) : null);
    });
  });
  var NAV_ON = 'border-accent bg-accent/15 text-accent';
  var NAV_OFF = 'border-transparent bg-[#151515]/40 text-white hover:text-white hover:bg-white/5';
  var navActive = '';
  function updateNavActive() {
    if (!navItems.length) return;
    var cur = navItems[0].getAttribute('data-no-val');
    var lim = window.innerHeight * 0.35;
    navItems.forEach(function (b) {
      var id = b.getAttribute('data-no-val');
      var s = id ? document.getElementById(id) : null;
      if (s && s.getBoundingClientRect().top <= lim) cur = id;
    });
    if (cur === navActive) return;
    navActive = cur;
    navItems.forEach(function (b) {
      var on = b.getAttribute('data-no-val') === cur;
      swapCls(b, on ? NAV_OFF : NAV_ON, on ? NAV_ON : NAV_OFF);
      var num = b.querySelector('span');
      if (num) num.classList.toggle('text-white/70', !on);
    });
  }
  var inView = false;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      if (navOpen) navOpen.style.display = inView ? '' : 'none';
      if (!inView) { setNav(false); }
      toggleSticky();
    }, { threshold: 0 }).observe(root);
  }

  /* ---------------------------------------------------------------- 5. sticky CTA bars */
  var stickyDesk = hook('sticky-desktop'), stickyMob = hook('sticky-mobile');
  var hero = root.querySelector('section');
  if (stickyDesk) stickyDesk.style.top = 'var(--no-sticky-cta-top, var(--no-sticky-top, 0px))';
  function toggleSticky() {
    var show = inView;
    if (show && hero) { show = hero.getBoundingClientRect().bottom <= 80; }
    var kitBox = document.getElementById('no-predator-kit');
    if (show && kitBox) { var kr = kitBox.getBoundingClientRect(); if (kr.top < window.innerHeight && kr.bottom > 0) show = false; }
    var buy = hook('buy');
    if (show && buy) { var br = buy.getBoundingClientRect(); if (br.top < window.innerHeight && br.bottom > 0) show = false; }
    if (stickyDesk) {
      stickyDesk.classList.toggle('-translate-y-full', !show); stickyDesk.classList.toggle('translate-y-0', show);
      stickyDesk.style.transform = show ? 'translateY(0)' : 'translateY(calc(-100% - 240px))';
    }
    if (stickyMob) { stickyMob.classList.toggle('translate-y-full', !show); stickyMob.classList.toggle('translate-y-0', show); }
  }
  var scrollFns = [];
  var activeUntil = 0, looping = false;
  function loop(ts) {
    place(); toggleSticky(); updateNavActive();
    for (var i = 0; i < scrollFns.length; i++) { try { scrollFns[i](); } catch (e) {} }
    if (ts < activeUntil) requestAnimationFrame(loop); else looping = false;
  }
  function wake() { activeUntil = performance.now() + 900; if (!looping) { looping = true; requestAnimationFrame(loop); } }
  place(); toggleSticky();
  window.addEventListener('scroll', wake, { passive: true });
  window.addEventListener('resize', wake);
  window.addEventListener('orientationchange', wake);
  window.addEventListener('load', wake);
  setTimeout(wake, 600); setTimeout(wake, 1800);

  /* ---------------------------------------------------------------- 6. in-page anchors */
  $$('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = a.getAttribute('href').slice(1);
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      try { history.replaceState(null, '', '#' + id); } catch (err) {}
    });
  });

  /* ---------------------------------------------------------------- 7. FAQ accordion */
  var faqItems = hooks('faq-item');
  faqItems.forEach(function (item) {
    var btn = $('[data-no="faq-toggle"]', item), ans = $('[data-no="faq-answer"]', item), sign = $('[data-no="faq-sign"]', item);
    if (!btn || !ans) return;
    btn.addEventListener('click', function () {
      var open = ans.hidden;
      faqItems.forEach(function (o) {
        var oa = $('[data-no="faq-answer"]', o), ob = $('[data-no="faq-toggle"]', o), os = $('[data-no="faq-sign"]', o);
        if (oa) oa.hidden = true; if (ob) ob.setAttribute('aria-expanded', 'false'); if (os) os.textContent = '+';
      });
      if (open) { ans.hidden = false; btn.setAttribute('aria-expanded', 'true'); if (sign) sign.textContent = '−'; }
    });
  });

  /* ---------------------------------------------------------------- 8. section 03: compare tabs, limits */
  var TAB_ON = 'bg-accent/15 border-accent text-accent';
  var TAB_OFF = 'bg-surface border-border-bright text-muted-foreground hover:border-accent/60 hover:text-foreground';
  var EDU = [
    { key: 'eye', callout: 'Without night vision or thermal, our eyes see nothing.' },
    { key: 'nv', callout: 'With infrared night vision, we can see the man in the forest, but he blends in with the shade, lacking contrast.' },
    { key: 'thermal', callout: "With the PREDATOR's thermal imager, you can see humans and animals with ease, day or night." },
    { key: 'fusion', callout: 'With the PREDATOR bridged with night vision, you see a highlight on subjects while maintaining surface detail of the surrounding scene.' }
  ];
  var eduImage = document.getElementById('edu-image');
  var eduTabs = hooks('compare-tab');
  var eduImgs = eduImage ? $$('img', eduImage) : [];
  var eduCallout = hook('edu-callout');
  var eduBanner = null;
  if (eduImage) {
    eduBanner = el('div', 'absolute top-0 inset-x-0 z-10 mono text-[11px] tracking-[0.14em] uppercase bg-black/70 text-foreground/90 px-3 py-1.5 text-center backdrop-blur-sm');
    eduBanner.textContent = 'Analog devices sold separately';
    eduBanner.hidden = true;
    eduImage.insertBefore(eduBanner, eduImage.firstChild);
  }
  function setEdu(i) {
    eduTabs.forEach(function (t, j) {
      var on = j === i;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      swapCls(t, on ? TAB_OFF : TAB_ON, on ? TAB_ON : TAB_OFF);
      if (eduImgs[j]) { eduImgs[j].classList.toggle('opacity-100', on); eduImgs[j].classList.toggle('opacity-0', !on); eduImgs[j].setAttribute('aria-hidden', on ? 'false' : 'true'); }
    });
    if (eduCallout && EDU[i]) eduCallout.textContent = EDU[i].callout;
    if (eduBanner) eduBanner.hidden = !(EDU[i] && (EDU[i].key === 'nv' || EDU[i].key === 'fusion'));
  }
  eduTabs.forEach(function (t, i) { t.addEventListener('click', function () { setEdu(i); }); });
  function eduJump(key) {
    var i = EDU.map(function (e) { return e.key; }).indexOf(key);
    if (i < 0) return;
    setEdu(i);
    requestAnimationFrame(function () {
      if (!eduImage) return;
      var c = eduImage.getBoundingClientRect();
      window.scrollTo({ top: window.scrollY + c.top + c.height / 2 - window.innerHeight / 2, behavior: 'smooth' });
    });
  }
  hooks('edu-fusion').forEach(function (b) { b.addEventListener('click', function () { eduJump('fusion'); }); });
  var limits = hook('limits-toggle'), limitsGrid = hook('limits-grid'), limitsFade = hook('limits-fade');
  var limitsOpen = false;
  if (limits) {
    var limitsSvg = limits.querySelector('svg path');
    limits.addEventListener('click', function () {
      limitsOpen = !limitsOpen;
      if (limitsGrid) { swapCls(limitsGrid, limitsOpen ? 'max-h-[430px] md:max-h-[470px]' : 'max-h-[3000px]', limitsOpen ? 'max-h-[3000px]' : 'max-h-[430px] md:max-h-[470px]'); }
      if (limitsFade) limitsFade.hidden = limitsOpen;
      limits.firstChild.textContent = limitsOpen ? 'SHOW LESS' : 'SHOW ALL 4 LIMITS';
      if (limitsSvg) limitsSvg.setAttribute('d', limitsOpen ? 'm18 15-6-6-6 6' : 'm6 9 6 6 6-6');
    });
  }

  /* ---------------------------------------------------------------- 9. section 04: role tabs */
  var ROLES = [
    { name: 'HANDHELD', copy: 'Pull it from a pocket and scan a treeline in seconds.' },
    { name: 'HELMET-MOUNTED', copy: 'Standard dovetail interface. Drops into the same helmet mounts and J-arms the night vision world already runs.' },
    { name: 'DIRECT-MOUNT', copy: 'Recoil-tested and built to hold. Mount it to your setup and it keeps its setting.' },
    { name: 'CLIP-ON', copy: 'Runs in-line ahead of your existing optic. Your setup stays exactly as you had it.' }
  ];
  var roleTabs = hooks('role-tab');
  var roleImgs = roleTabs.length ? $$('img.absolute.inset-0', roleTabs[0].parentElement.parentElement) : [];
  var roleNum = hook('role-num'), roleName = hook('role-name'), roleCopy = hook('role-copy');
  var roleIdx = 0;
  function setRole(i) {
    roleIdx = i;
    roleTabs.forEach(function (t, j) {
      var on = j === i;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      swapCls(t, on ? TAB_OFF : TAB_ON, on ? TAB_ON : TAB_OFF);
      var svg = t.querySelector('svg'); if (svg) svg.classList.toggle('text-accent', on);
      if (roleImgs[j]) { roleImgs[j].classList.toggle('opacity-100', on); roleImgs[j].classList.toggle('opacity-0', !on); roleImgs[j].setAttribute('aria-hidden', on ? 'false' : 'true'); }
    });
    if (roleNum) roleNum.textContent = 'ROLE ' + ('0' + (i + 1)).slice(-2);
    if (roleName && ROLES[i]) roleName.textContent = ROLES[i].name;
    if (roleCopy && ROLES[i]) roleCopy.textContent = ROLES[i].copy;
  }
  roleTabs.forEach(function (t, i) { t.addEventListener('click', function () { setRole(i); }); });

  /* ================================================================ 10. section 05: INTERACTIVE THERMAL VIEWER */
  var S5 = (function () {
    var sec = hook('s5');
    if (!sec) return null;
    var P = function (f) { return ASSET + f; };
    var PAL = [
      { key: 'white-hot', name: 'WHITE HOT' }, { key: 'white-red', name: 'WHITE-RED' }, { key: 'white-yellow', name: 'WHITE-YELLOW' },
      { key: 'red-orange-hot', name: 'RED-ORANGE HOT' }, { key: 'iron-orange', name: 'IRON ORANGE' }, { key: 'ironbow-blue-red', name: 'IRONBOW' },
      { key: 'blue-green', name: 'BLUE-GREEN' }, { key: 'green-hot', name: 'GREEN HOT' }
    ];
    var FRAMES = {
      48: {
        'white-hot-high': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-white-hot_contrast-high.webp?v=1788746430',
        'white-hot-low': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-white-hot_contrast-low.webp?v=1788746188',
        'white-red': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-white-red.webp?v=1788746430',
        'white-yellow': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-white-yellow.webp?v=1788746308',
        'red-orange-hot': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-red-orange-hot.webp?v=1788746308',
        'iron-orange': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-iron-orange.webp?v=1788746430',
        'ironbow-blue-red': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-ironbow-blue-red.webp?v=1788746430',
        'blue-green': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-blue-green.webp?v=1788746308',
        'green-hot': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p48-green-hot.webp?v=1788746308'
      },
      13: {
        'white-hot-high': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-white-hot_contrast-high.webp?v=1788746309',
        'white-hot-low': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-white-hot_contrast-low.webp?v=1788746308',
        'white-red': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-white-red.webp?v=1788746309',
        'white-yellow': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-white-yellow.webp?v=1788746308',
        'red-orange-hot': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-red-orange-hot.webp?v=1788746308',
        'iron-orange': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-iron-orange.webp?v=1788746308',
        'ironbow-blue-red': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-ironbow-blue-red.webp?v=1788746430',
        'blue-green': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-blue-green.webp?v=1788746430',
        'green-hot': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-p13-green-hot.webp?v=1788746308'
      }
    };
    var IMG = {
      logoOff: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-power-off-logo-screen.png?v=1788746430',
      crosshair: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-crosshair.png?v=1788746308',
      sceneOff: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-scene-torch-off.webp?v=1788744890',
      sceneOn: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-scene-torch-on.webp?v=1788745010',
      eotech: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-eotech-2.png?v=1788746309',
      reticle: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-eotech_magnified_crosshair.webp?v=1788745131',
      mag: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-eotech_magnified.webp?v=1788746430',
      vignette: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-vignette.webp?v=1788744889',
      housing: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-housing.png?v=1788746308',
      battery: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-battery.webp?v=1788743916'
    };
    var Mt = { top: 22.6, right: 36.9, bottom: 26.4, left: 32.6 };
    var ti = 100 - Mt.left - Mt.right, Bc = 100 - Mt.top - Mt.bottom, Qn = 0.375, CH = 255, DH = 240;
    var CLIP = 'inset(' + Mt.top + '% ' + Mt.right + '% ' + Mt.bottom + '% ' + Mt.left + '% round 4%)';
    var ot = { cx: 50, cy: 47, r: 32.4 };
    var CIRCLE = 'circle(' + ot.r + '% at ' + ot.cx + '% ' + ot.cy + '%)';
    var BTN_ON = 'bg-accent/30 border-accent text-accent';
    var BTN_OFF = 'bg-white/10 border-white/25 text-white hover:bg-white/20';
    var BTN_DIS = 'bg-white/5 border-white/10 text-white/30 cursor-not-allowed';
    var HAND = '<path d="M18 11V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2"></path><path d="M14 10V4a2 2 0 0 0-2-2a2 2 0 0 0-2 2v2"></path><path d="M10 10.5V6a2 2 0 0 0-2-2a2 2 0 0 0-2 2v8"></path><path d="M18 8a2 2 0 1 1 4 0v6a8 8 0 0 1-8 8h-2c-2.8 0-4.5-.86-5.99-2.34l-3.6-3.6a2 2 0 0 1 2.83-2.82L7 15"></path>';
    var EYE = '<path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path><circle cx="12" cy="12" r="3"></circle>';

    var st = null;
    function fresh() {
      return { lens: '48', light: false, equipped: false, equipAnim: 'off', power: true, eotech: false, mag: false, magAnim: 'off',
        showEquip: true, step: 0, pal: 7, zoom: 1, x: 30.75, y: 3.75, contrast: 5, bright: 5, bar: null, interacted: false };
    }
    st = fresh();
    var magReady = false;
    var timers = {};
    function later(key, fn, ms) { if (timers[key]) clearTimeout(timers[key]); timers[key] = setTimeout(function () { timers[key] = null; fn(); }, ms); }
    function cancel(key) { if (timers[key]) { clearTimeout(timers[key]); timers[key] = null; } }

    // ---- DOM refs
    var scene = hook('s5-scene');
    var sceneOff = hook('s5-scene-off'), sceneOn = hook('s5-scene-on'), eotechImg = hook('s5-eotech-img'), reticleImg = hook('s5-reticle-img');
    var lensBtns = hooks('s5-lens'), equipBtns = hooks('s5-equip'), lightBtns = hooks('s5-light'), eotechBtns = hooks('s5-eotech'), magBtns = hooks('s5-mag'), powerBtns = hooks('s5-power');
    var keys = hooks('s5-key'), resetBtn = hook('s5-reset');
    var hudZoom = $('[data-no="s5-hud"][data-no-val="zoom"]', sec), hudCross = $('[data-no="s5-hud"][data-no-val="cross"]', sec), hudPal = $('[data-no="s5-hud"][data-no-val="pal"]', sec);
    var toasts = hooks('s5-toast'), tries = hooks('s5-try');
    var stickerEquip = hook('s5-sticker');
    if (!scene || !sceneOff) return null;

    // ---- the device overlay (the Lovable _o fragment), built twice: main scene + magnifier clone
    function makeDevice() {
      var d = {};
      d.el = el('div', '', 'position:absolute;inset:0;');
      d.off = el('div', '', 'position:absolute;inset:0;pointer-events:none;transition:opacity 250ms;overflow:hidden;clip-path:' + CLIP + ';-webkit-clip-path:' + CLIP);
      d.off.setAttribute('aria-hidden', 'true');
      var l1 = el('img', 'absolute inset-0 w-full h-full object-fill'); l1.src = IMG.logoOff; l1.alt = ''; l1.draggable = false;
      var l2 = el('img', 'absolute inset-0 w-full h-full object-fill s5-logo-glow'); l2.src = IMG.logoOff; l2.alt = ''; l2.draggable = false;
      d.off.appendChild(l1); d.off.appendChild(l2);
      d.therm = el('div', '', 'position:absolute;inset:0;transition:opacity 300ms;overflow:hidden;clip-path:' + CLIP + ';-webkit-clip-path:' + CLIP);
      d.prev = el('img', 'absolute inset-0 w-full h-full object-fill'); d.prev.alt = ''; d.prev.draggable = false; d.prev.hidden = true;
      d.cur = el('img', 'absolute inset-0 w-full h-full object-fill', 'transition:opacity 220ms ease-out'); d.cur.alt = ''; d.cur.draggable = false;
      d.therm.appendChild(d.prev); d.therm.appendChild(d.cur);
      d.crossWrap = el('div', '', 'position:absolute;inset:0;pointer-events:none;transition:opacity 300ms;overflow:hidden;clip-path:' + CLIP + ';-webkit-clip-path:' + CLIP);
      d.cross = el('img', '', 'position:absolute;display:block;user-select:none;pointer-events:none;mix-blend-mode:difference;width:3.35%;aspect-ratio:1/1;transform:translate(-50%,-50%);image-rendering:pixelated');
      d.cross.src = IMG.crosshair; d.cross.alt = ''; d.cross.draggable = false;
      d.crossWrap.appendChild(d.cross);
      d.barWrap = el('div', '', 'position:absolute;pointer-events:none;left:' + (Mt.left + ti * 0.15) + '%;top:' + (Mt.top + Bc * 0.82) + '%;width:' + (ti * 0.7) + '%');
      d.barWrap.hidden = true; d.barWrap.setAttribute('data-no', 's5-bar');
      d.barLabel = el('div', 'mono text-[11px] tracking-[0.18em] uppercase text-white/90 mb-1 drop-shadow');
      var track = el('div', 'h-[6px] w-full bg-black/60 border border-white/40 relative');
      d.barFill = el('div', 'absolute inset-y-0 left-0 bg-white');
      track.appendChild(d.barFill);
      d.barWrap.appendChild(d.barLabel); d.barWrap.appendChild(track);
      var v = el('img', 'absolute inset-0 w-full h-full object-fill pointer-events-none'); v.src = IMG.vignette; v.alt = ''; v.loading = 'lazy'; v.draggable = false;
      var h = el('img', 'absolute inset-0 w-full h-full object-fill pointer-events-none'); h.src = IMG.housing; h.alt = ''; h.loading = 'lazy'; h.draggable = false;
      d.batt = el('img', 'absolute inset-0 w-full h-full object-fill pointer-events-none', 'transition:opacity 300ms'); d.batt.src = IMG.battery; d.batt.alt = ''; d.batt.loading = 'lazy'; d.batt.draggable = false;
      d.el.appendChild(d.off); d.el.appendChild(d.therm); d.el.appendChild(d.crossWrap); d.el.appendChild(d.barWrap); d.el.appendChild(v); d.el.appendChild(h); d.el.appendChild(d.batt);
      d.frame = '';
      return d;
    }
    function frameKey() { var p = PAL[st.pal]; return p.key === 'white-hot' ? (st.contrast > 5 ? 'white-hot-high' : 'white-hot-low') : p.key; }
    function renderDevice(d) {
      var url = FRAMES[st.lens][frameKey()];
      var pn = Mt.left + ti / 2 + st.x / 510 * ti, cs = Mt.top + Bc / 2 + st.y / 480 * Bc;
      var filter = 'contrast(' + (0.7 + st.contrast / 10 * 0.8) + ') brightness(' + (0.7 + st.bright / 10 * 0.7) + ')';
      var tf = 'scale(' + st.zoom + ')';
      var origin = pn + '% ' + cs + '%';
      d.off.style.opacity = st.power ? '0' : '1';
      d.therm.style.opacity = st.power ? '1' : '0';
      d.crossWrap.style.opacity = st.power ? '1' : '0';
      d.batt.style.opacity = st.power ? '1' : '0';
      if (d.frame !== url) {
        if (d.frame) { d.prev.src = d.frame; d.prev.hidden = false; }
        d.frame = url;
        d.cur.style.opacity = '0';
        d.cur.src = url;
        var self = d;
        setTimeout(function () { if (self.frame === url) self.cur.style.opacity = '1'; }, 30);
      }
      [d.prev, d.cur].forEach(function (im) { im.style.transform = tf; im.style.transformOrigin = origin; im.style.filter = filter; });
      d.cross.style.left = pn + '%'; d.cross.style.top = cs + '%';
      var showBar = st.power && !!st.bar;
      d.barWrap.hidden = !showBar;
      if (showBar) { d.barLabel.textContent = st.bar === 'contrast' ? 'CONTRAST' : 'BRIGHTNESS'; d.barFill.style.width = ((st.bar === 'contrast' ? st.contrast : st.bright) / 10 * 100) + '%'; }
    }

    // ---- scene layers
    var devWrap = el('div', '', 'position:absolute;inset:0;');
    devWrap.hidden = true;
    var dev = makeDevice();
    devWrap.appendChild(dev.el);
    sceneOn.parentNode.insertBefore(devWrap, sceneOn.nextSibling);

    var magWrap = el('div', '', 'position:absolute;inset:0;pointer-events:none;transform-origin:50% 100%;will-change:transform,filter,opacity');
    magWrap.hidden = true;
    magWrap.setAttribute('aria-hidden', 'true');
    var magScene = el('div', '', 'position:absolute;inset:0;pointer-events:none;overflow:hidden;clip-path:' + CIRCLE + ';-webkit-clip-path:' + CIRCLE);
    var magSceneIn = el('div', '', 'position:absolute;inset:0;transform:scale(3);transform-origin:' + ot.cx + '% ' + ot.cy + '%');
    var magOff = el('img', 'absolute inset-0 w-full h-full object-fill', 'filter:brightness(1.15);transition:opacity 300ms'); magOff.src = IMG.sceneOff; magOff.alt = ''; magOff.draggable = false;
    var magOn = el('img', 'absolute inset-0 w-full h-full object-fill', 'filter:brightness(1.15);transition:opacity 300ms'); magOn.src = IMG.sceneOn; magOn.alt = ''; magOn.draggable = false;
    magSceneIn.appendChild(magOff); magSceneIn.appendChild(magOn); magScene.appendChild(magSceneIn); magWrap.appendChild(magScene);
    var magDevClip = el('div', '', 'position:absolute;inset:0;pointer-events:none;overflow:hidden;clip-path:' + CIRCLE + ';-webkit-clip-path:' + CIRCLE);
    var magDevAnim = el('div', '', 'position:absolute;inset:0;');
    var magDevIn = el('div', '', 'position:absolute;inset:0;transform:translate(3px,-20px) scale(3);transform-origin:' + ot.cx + '% ' + ot.cy + '%');
    var dev2 = makeDevice();
    magDevIn.appendChild(dev2.el);
    var grid1 = el('div', '', 'position:absolute;inset:0;mix-blend-mode:overlay;opacity:.7;clip-path:' + CIRCLE + ';-webkit-clip-path:' + CIRCLE + ';background-image:repeating-linear-gradient(0deg, rgba(0,0,0,0.55) 0px, rgba(0,0,0,0.55) 1px, transparent 1px, transparent 3px), repeating-linear-gradient(90deg, rgba(255,0,0,0.18) 0px, rgba(0,255,0,0.18) 1px, rgba(0,0,255,0.18) 2px, transparent 3px);background-size:3px 3px, 3px 3px');
    var grid2 = el('div', '', 'position:absolute;inset:0;mix-blend-mode:screen;opacity:.3;clip-path:' + CIRCLE + ';-webkit-clip-path:' + CIRCLE + ';background-image:repeating-linear-gradient(6deg, rgba(255,255,255,0.08) 0px, rgba(255,255,255,0.08) 1px, transparent 1px, transparent 5px), repeating-linear-gradient(96deg, rgba(255,255,255,0.06) 0px, rgba(255,255,255,0.06) 1px, transparent 1px, transparent 5px)');
    magDevAnim.appendChild(magDevIn); magDevAnim.appendChild(grid1); magDevAnim.appendChild(grid2); magDevClip.appendChild(magDevAnim); magWrap.appendChild(magDevClip);
    var magShade = el('div', '', 'position:absolute;inset:0;pointer-events:none;overflow:hidden;clip-path:' + CIRCLE + ';-webkit-clip-path:' + CIRCLE);
    var shade1 = el('div', '', 'position:absolute;inset:0;background:radial-gradient(circle at ' + ot.cx + '% ' + ot.cy + '%, transparent 55%, rgba(0,0,0,0.45) 82%, rgba(0,0,0,0.9) 96%, #000 100%)');
    var diopter = el('div', 's5-diopter-in absolute inset-0', 'background:radial-gradient(circle at ' + ot.cx + '% ' + ot.cy + '%, transparent 20%, rgba(0,0,0,0.6) 45%, #000 70%)');
    magShade.appendChild(shade1); magShade.appendChild(diopter); magWrap.appendChild(magShade);
    var magReticle = el('img', 'absolute inset-0 w-full h-full object-fill pointer-events-none', 'mix-blend-mode:screen;opacity:1;filter:drop-shadow(0 0 5px rgba(255,0,0,0.5)) drop-shadow(0 0 5px rgba(255,0,0,0.5)) drop-shadow(0 0 3px rgba(255,0,0,0.425)) drop-shadow(0 0 1.5px rgba(255,0,0,0.425))');
    magReticle.src = IMG.reticle; magReticle.alt = ''; magReticle.draggable = false;
    var magImg = el('img', 'absolute inset-0 w-full h-full object-fill pointer-events-none'); magImg.alt = ''; magImg.draggable = false;
    magWrap.appendChild(magReticle); magWrap.appendChild(magImg);
    (reticleImg || eotechImg || sceneOn).parentNode.insertBefore(magWrap, (reticleImg || eotechImg || sceneOn).nextSibling);

    // ---- toast
    function toast(text) {
      toasts.forEach(function (t) {
        t.innerHTML = '<div class="s5-hud-toast inline-flex items-center gap-2 mono uppercase tracking-[0.16em] text-[11px] text-white/95 drop-shadow-[0_0_6px_rgba(255,255,255,0.35)] whitespace-nowrap">' + DOT + '<span></span></div>';
        t.querySelector('span:last-child').textContent = text;
      });
      later('toast', function () { toasts.forEach(function (t) { t.innerHTML = ''; }); }, 1400);
    }

    // ---- stickers (PRESS TO EQUIP PREDATOR + the guided holosight / magnifier ones) with the desktop leader line
    var stickers = [];
    function makeSticker(node, label, targetId) {
      if (!node) return null;
      var s = { el: node, label: label, targetId: targetId, visible: false };
      var labels = $$('div', node).filter(function (d) { return txt(d) === 'PRESS TO EQUIP PREDATOR' && !d.querySelector('div'); });
      labels.forEach(function (d) { d.textContent = label; });
      s.desk = node.querySelector('.hidden.lg\\:block div div') || node.querySelector('.hidden.lg\\:block div');
      return s;
    }
    if (stickerEquip) {
      var sHolo = stickerEquip.cloneNode(true);
      stickerEquip.parentNode.insertBefore(sHolo, stickerEquip.nextSibling);
      
      stickers.push(makeSticker(stickerEquip, 'PRESS TO EQUIP PREDATOR', 's5-btn-equip'));
      stickers.push(makeSticker(sHolo, 'EQUIP HOLOSIGHT', 's5-btn-eotech'));
      
      stickers = stickers.filter(Boolean);
      sHolo.removeAttribute('data-no');
    }
    var leader = null, leaderPath = null, leaderDot = null, leaderRaf = 0;
    function ensureLeader() {
      if (leader) return;
      leader = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      leader.setAttribute('class', 'no-s5-leader s5-sticker-glow');
      leader.setAttribute('width', '100%'); leader.setAttribute('height', '100%'); leader.setAttribute('overflow', 'visible');
      leader.style.cssText = 'position:fixed;inset:0;z-index:60;pointer-events:none;width:100%;height:100%';
      leaderPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      leaderPath.setAttribute('stroke', 'hsl(var(--accent) / 0.85)'); leaderPath.setAttribute('stroke-width', '2'); leaderPath.setAttribute('fill', 'none'); leaderPath.setAttribute('stroke-linecap', 'round'); leaderPath.setAttribute('stroke-linejoin', 'round');
      leaderDot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      leaderDot.setAttribute('r', '6'); leaderDot.setAttribute('fill', 'hsl(var(--accent))'); leaderDot.setAttribute('opacity', '0.9');
      leader.appendChild(leaderPath); leader.appendChild(leaderDot);
      leader.style.color = getComputedStyle(root).getPropertyValue('--accent') ? '' : '';
      root.appendChild(leader);
    }
    function leaderFrame() {
      leaderRaf = 0;
      var s = null;
      for (var i = 0; i < stickers.length; i++) if (stickers[i].visible) { s = stickers[i]; break; }
      if (!s || window.innerWidth < 1024 || !s.desk) { if (leader) leader.style.display = 'none'; return; }
      var target = document.getElementById(s.targetId);
      if (!target) { if (leader) leader.style.display = 'none'; return; }
      var h = s.desk.getBoundingClientRect(), f = target.getBoundingClientRect();
      if (h.width === 0 || f.width === 0) { if (leader) leader.style.display = 'none'; return; }
      ensureLeader();
      var tx = f.left + f.width / 2, ty = f.top + f.height / 2;
      var o = tx > h.right ? h.right : tx < h.left ? h.left : tx, i2 = ty < h.top ? h.top : ty > h.bottom ? h.bottom : ty;
      leaderPath.setAttribute('d', 'M ' + o + ' ' + i2 + ' L ' + tx + ' ' + i2 + ' L ' + tx + ' ' + ty);
      leaderDot.setAttribute('cx', tx); leaderDot.setAttribute('cy', ty);
      leader.style.display = '';
      leaderRaf = requestAnimationFrame(leaderFrame);
    }
    var secVisible = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { secVisible = entries[0].isIntersecting; renderStickers(); }, { threshold: 0 }).observe(sec);
    } else { secVisible = true; }
    function renderStickers() {
      stickers.forEach(function (s) {
        var vis = (s.targetId === 's5-btn-equip') ? (!st.equipped && st.showEquip) : (s.targetId === 's5-btn-eotech') ? st.step === 2 : st.step === 3;
        s.visible = vis && secVisible;
        s.el.hidden = !vis;
      });
      var any = stickers.some(function (s) { return s.visible; });
      if (any && !leaderRaf && !reducedMotion) leaderRaf = requestAnimationFrame(leaderFrame);
      if (any && reducedMotion) leaderFrame();
      if (!any && leader) leader.style.display = 'none';
      tries.forEach(function (t) { t.classList.toggle('opacity-0', st.interacted); t.classList.toggle('opacity-100', !st.interacted); });
    }

    // ---- buttons
    function setBtn(b, on, dis) {
      rmCls(b, BTN_ON + ' ' + BTN_OFF + ' ' + BTN_DIS);
      addCls(b, dis ? BTN_DIS : on ? BTN_ON : BTN_OFF);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (dis) { b.setAttribute('disabled', ''); b.setAttribute('aria-disabled', 'true'); } else { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); }
    }
    function press(b) {
      b.style.background = 'hsl(var(--accent) / 0.4)';
      b.style.boxShadow = '0 0 18px hsl(var(--accent) / 0.7), inset 0 0 10px hsl(var(--accent) / 0.5)';
      b.style.transform = 'scale(0.94)';
      setTimeout(function () { if (b.getAttribute('data-no-val') === 'gear' && st.bar) return; b.style.background = ''; b.style.boxShadow = ''; b.style.transform = ''; }, 180);
    }

    // ---- render everything from state
    function render() {
      if (sceneOff) { sceneOff.classList.toggle('opacity-0', st.light); sceneOff.classList.toggle('opacity-100', !st.light); }
      if (sceneOn) { sceneOn.classList.toggle('opacity-100', st.light); sceneOn.classList.toggle('opacity-0', !st.light); }
      magOff.style.opacity = st.light ? '0' : '1'; magOn.style.opacity = st.light ? '1' : '0';
      // device overlay
      devWrap.hidden = st.equipAnim === 'off';
      devWrap.className = st.equipAnim === 'in' ? 's5-equip-in' : st.equipAnim === 'out' ? 's5-equip-out pointer-events-none' : '';
      devWrap.setAttribute('aria-hidden', st.equipped ? 'false' : 'true');
      renderDevice(dev); renderDevice(dev2);
      // eotech
      if (eotechImg) { eotechImg.classList.toggle('opacity-100', st.eotech || st.mag); eotechImg.classList.toggle('opacity-0', !(st.eotech || st.mag)); }
      if (reticleImg) { var showRet = st.eotech && st.magAnim === 'off'; reticleImg.classList.toggle('opacity-100', showRet); reticleImg.classList.toggle('opacity-0', !showRet); }
      // magnifier
      magWrap.hidden = st.magAnim === 'off';
      magWrap.className = st.magAnim === 'out' ? 's5-mag-out' : 's5-mag-in';
      magDevClip.hidden = st.equipAnim === 'off';
      magDevAnim.className = st.equipAnim === 'in' ? 's5-equip-in' : st.equipAnim === 'out' ? 's5-equip-out' : '';
      diopter.className = (st.magAnim === 'out' ? 's5-diopter-out' : 's5-diopter-in') + ' absolute inset-0';
      // HUD
      var off = !st.power || !st.equipped;
      if (hudZoom) hudZoom.textContent = off ? 'DEVICE OFF' : st.zoom.toFixed(1) + 'X';
      if (hudCross) hudCross.textContent = off ? 'OFF' : st.x + ',' + st.y;
      if (hudPal) hudPal.textContent = off ? 'DEVICE OFF' : PAL[st.pal].name;
      // buttons
      lensBtns.forEach(function (b) {
        var on = b.getAttribute('data-no-val') === st.lens;
        swapCls(b, on ? 'bg-background text-foreground hover:text-accent' : 'bg-accent text-accent-foreground', on ? 'bg-accent text-accent-foreground' : 'bg-background text-foreground hover:text-accent');
      });
      equipBtns.forEach(function (b) {
        setBtn(b, st.equipped, false);
        b.setAttribute('aria-label', st.equipped ? 'Unequip PREDATOR' : 'Equip PREDATOR');
        var svg = b.querySelector('svg'); if (svg) { svg.innerHTML = st.equipped ? EYE : HAND; svg.setAttribute('class', svg.getAttribute('class').replace(/lucide-(hand|eye)/, st.equipped ? 'lucide-eye' : 'lucide-hand')); }
      });
      lightBtns.forEach(function (b) { setBtn(b, st.light, false); });
      eotechBtns.forEach(function (b) { setBtn(b, st.eotech, false); });
      magBtns.forEach(function (b) { setBtn(b, st.mag, false); b.setAttribute('aria-disabled', magReady ? 'false' : 'true'); b.classList.toggle('opacity-50', !magReady); b.classList.toggle('cursor-wait', !magReady); b.title = magReady ? 'Toggle EOTech 3x magnifier' : 'Loading magnifier assets…'; });
      powerBtns.forEach(function (b) { setBtn(b, st.power, !st.equipped); b.title = st.equipped ? 'Power on / off' : 'Equip PREDATOR first'; });
      keys.forEach(function (b) {
        if (b.getAttribute('data-no-val') !== 'gear') return;
        if (st.bar) { b.style.background = 'hsl(var(--accent) / 0.4)'; b.style.boxShadow = '0 0 18px hsl(var(--accent) / 0.7), inset 0 0 10px hsl(var(--accent) / 0.5)'; b.style.transform = 'scale(0.94)'; }
        else { b.style.background = ''; b.style.boxShadow = ''; b.style.transform = ''; }
      });
      renderStickers();
    }

    // ---- actions (the Lovable handlers, verbatim in behaviour)
    function setEquipped(on) {
      st.equipped = on;
      if (on) { st.equipAnim = 'in'; later('equip', function () { st.equipAnim = 'on'; render(); }, 640); }
      else { st.equipAnim = st.equipAnim === 'off' ? 'off' : 'out'; later('equip', function () { st.equipAnim = 'off'; render(); }, 560); }
    }
    function setMag(on) {
      st.mag = on;
      cancel('mag');
      if (on) { st.magAnim = 'in'; later('mag', function () { st.magAnim = 'on'; render(); }, 520); }
      else if (st.magAnim === 'in' || st.magAnim === 'on') { st.magAnim = 'out'; later('mag', function () { st.magAnim = 'off'; render(); }, 520); }
    }
    function equip() {
      st.interacted = true; st.showEquip = false;
      var G = !st.equipped;
      if (G && st.step === 1) st.step = 2;
      setEquipped(G);
      toast(G ? 'PREDATOR EQUIPPED' : 'UNEQUIPPED');
      render();
    }
    function light() { st.light = !st.light; toast(st.light ? 'LIGHT ON' : 'LIGHT OFF'); render(); }
    function eotech() {
      if (st.eotech && st.mag) {
        setMag(false); toast('EOTECH MAG OFF');
        later('eotechOff', function () { st.eotech = false; toast('EOTECH OFF'); render(); }, 540);
        render(); return;
      }
      var G = !st.eotech;
      if (G && st.step === 2) st.step = 3;
      if (!G) setMag(false);
      st.eotech = G;
      toast(G ? 'EOTECH ON' : 'EOTECH OFF');
      render();
    }
    function mag() {
      if (!magReady) { toast('LOADING…'); return; }
      var G = !st.mag;
      if (G) { st.eotech = true; if (st.step === 3) st.step = 0; }
      setMag(G);
      toast(G ? 'EOTECH MAG ON' : 'EOTECH MAG OFF');
      render();
    }
    function power() { if (!st.equipped) return; st.power = !st.power; toast(st.power ? 'POWER ON' : 'POWER OFF'); render(); }
    function gear() {
      st.bar = st.bar === null ? 'contrast' : st.bar === 'contrast' ? 'brightness' : null;
      toast(st.bar ? st.bar.toUpperCase() : 'BAR OFF');
      cancel('bar'); if (st.bar) later('bar', function () { st.bar = null; render(); }, 5000);
      render();
    }
    function palette() { if (!st.power) return; st.pal = (st.pal + 1) % PAL.length; toast(PAL[st.pal].name.toUpperCase()); render(); }
    function zoom() { var G = Math.round((st.zoom + 0.2) * 10) / 10; st.zoom = G > 3 ? 1 : G; toast('ZOOM ' + st.zoom.toFixed(1) + 'X'); render(); }
    function nudge(dx, dy, label) {
      st.x = Math.max(-CH, Math.min(CH, Math.round((st.x + dx) * 1000) / 1000));
      st.y = Math.max(-DH, Math.min(DH, Math.round((st.y + dy) * 1000) / 1000));
      toast(label); render();
    }
    function adjust(z) {
      if (!st.bar) return;
      toast(st.bar.toUpperCase() + ' ' + (z === 1 ? '+' : '-'));
      if (st.bar === 'contrast') st.contrast = Math.max(0, Math.min(10, st.contrast + z));
      if (st.bar === 'brightness') st.bright = Math.max(0, Math.min(10, st.bright + z));
      cancel('bar'); later('bar', function () { st.bar = null; render(); }, 5000);
      render();
    }
    function reset() {
      var keep = { interacted: st.interacted };
      cancel('equip'); cancel('mag'); cancel('bar'); cancel('eotechOff');
      st = fresh();
      st.interacted = keep.interacted;
      toast('RESET');
      render();
    }
    function jump(opts) {
      opts = opts || {};
      reset();
      st.step = opts.clipOn ? 1 : 0;
      if (opts.equip) { st.equipped = true; st.equipAnim = 'on'; st.showEquip = false; }
      if (opts.lens) st.lens = opts.lens;
      if (opts.eotech) st.eotech = true;
      render();
      var sec5 = document.getElementById('controls');
      if (sec5) sec5.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    lensBtns.forEach(function (b) { b.addEventListener('click', function () { st.lens = b.getAttribute('data-no-val'); st.power = true; if (!st.equipped) setEquipped(true); st.equipped = true; st.showEquip = false; toast(st.lens === '48' ? '4MM LENS' : '13MM LENS'); render(); }); });
    equipBtns.forEach(function (b) { b.addEventListener('click', equip); });
    lightBtns.forEach(function (b) { b.addEventListener('click', light); });
    eotechBtns.forEach(function (b) { b.addEventListener('click', eotech); });
    magBtns.forEach(function (b) { b.addEventListener('click', mag); });
    powerBtns.forEach(function (b) { b.addEventListener('click', power); });
    if (resetBtn) resetBtn.addEventListener('click', reset);
    keys.forEach(function (b) {
      var k = b.getAttribute('data-no-val');
      var onPress = function () { st.interacted = true; press(b); };
      if (k === 'power') {
        var start = function (e) { onPress(); cancel('hold'); later('hold', function () { st.power = !st.power; toast(st.power ? 'POWER ON' : 'POWER OFF'); render(); }, 700); if (e && e.type === 'touchstart') e.preventDefault(); };
        var stop = function () { cancel('hold'); };
        b.addEventListener('mousedown', start); b.addEventListener('mouseup', stop); b.addEventListener('mouseleave', stop);
        b.addEventListener('touchstart', start, { passive: false }); b.addEventListener('touchend', stop);
        return;
      }
      b.addEventListener('click', function () {
        onPress();
        if (k === 'left') nudge(-Qn, 0, 'LEFT');
        else if (k === 'right') nudge(Qn, 0, 'RIGHT');
        else if (k === 'down') nudge(0, Qn, 'DOWN');
        else if (k === 'up') nudge(0, -Qn, 'UP');
        else if (k === 'palette') palette();
        else if (k === 'zoom') zoom();
        else if (k === 'gear') gear();
        else if (k === 'inc') adjust(1);
        else if (k === 'dec') adjust(-1);
        render();
      });
    });

    // ---- preload the palette frames + the three overlays that gate the magnifier
    (function preload() {
      var list = [IMG.eotech, IMG.reticle];
      Object.keys(FRAMES[48]).forEach(function (k) { list.push(FRAMES[48][k]); });
      Object.keys(FRAMES[13]).forEach(function (k) { list.push(FRAMES[13][k]); });
      var gate = 2;
      function go() {
        list.forEach(function (u) {
          var im = new Image(); im.decoding = 'async';
          var isGate = u === IMG.eotech || u === IMG.mag || u === IMG.reticle;
          im.onload = im.onerror = function () { if (isGate) { gate -= 1; if (gate <= 0 && !magReady) { magReady = true; render(); } } };
          im.src = u;
        });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '600px 0px' });
        io.observe(sec);
      } else go();
    }());

    render();
    return { jump: jump, reset: reset, state: function () { return st; } };
  }());
  hooks('jump-controls').forEach(function (b) {
    b.addEventListener('click', function () { if (S5) S5.jump({ clipOn: roleIdx === 3 }); else { var c = document.getElementById('controls'); if (c) c.scrollIntoView({ behavior: 'smooth' }); } });
  });

  /* ================================================================ 11. section 14: RANGE SIMULATOR (canvas) */
  var RS = (function () {
    var box = hook('rs');
    if (!box) return null;
    var P = function (f) { return ASSET + f; };
    var Re = 320, KN = 144, JN = 1.6;
    var FOV = { '4_8': 42.06, '13': 13.53 };
    var HEIGHT = { coyote: 0.6, deer: 1.1, man: 1.8, truck: 1.9 };
    var FLOOR = { '4_8': 143, '13': 144 };
    var PLATE = { '4_8': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-plate-48.png?v=1788746308', '13': 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-plate-13.png?v=1788746309' };
    var SUBJ = { coyote: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-subj-coyote.png?v=1788746308', deer: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-subj-deer.png?v=1788746430', man: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-subj-man.png?v=1788746308', truck: 'https://cdn.shopify.com/s/files/1/0676/8335/2822/files/predator-subj-truck.webp?v=1788745010' };
    var LENS_LABEL = { '4_8': '4MM', '13': '13MM' };
    var SUBJ_LABEL = { coyote: 'COYOTE', deer: 'DEER', man: 'MAN', truck: 'TRUCK' };
    var DIST = [10, 25, 75, 100, 150, 300, 600];
    var ZOOMS = [1, 1.2, 1.4, 1.6, 1.8, 2, 2.2, 2.4, 2.6, 2.8, 3];
    var SEL_ON = 'border-accent text-accent bg-accent/10';
    var SEL_OFF = 'border-border text-muted-foreground hover:text-foreground hover:border-border-bright';
    var st = { lens: '4_8', subject: 'deer', dist: 150, zi: 0 };
    var canvA = $('[data-no="rs-canvas"][data-no-val="a"]', box), canvB = $('[data-no="rs-canvas"][data-no-val="b"]', box), frame = hook('rs-frame');
    var lensBtns = hooks('rs-lens'), subjBtns = hooks('rs-subject'), zoomBtns = hooks('rs-zoom'), slider = hook('rs-distance'), ticks = hooks('rs-tick'), zoomLabel = hook('rs-zoom-label');
    var hud = {}; hooks('rs-hud').forEach(function (h) { hud[h.getAttribute('data-no-val')] = h; });
    if (!canvA || !canvB) return null;
    var cache = {};
    function load(u) {
      if (cache[u]) return cache[u];
      cache[u] = new Promise(function (res, rej) { var im = new Image(); im.crossOrigin = 'anonymous'; im.decoding = 'async'; im.onload = function () { res(im); }; im.onerror = function () { delete cache[u]; rej(new Error('load ' + u)); }; im.src = u; });
      return cache[u];
    }
    function gamma(img, w, h, g) {
      var c = document.createElement('canvas'); c.width = w; c.height = h;
      var o = c.getContext('2d'); if (!o) return img;
      o.drawImage(img, 0, 0, w, h);
      try {
        var d = o.getImageData(0, 0, w, h), a = d.data, inv = 1 / g;
        for (var i = 0; i < a.length; i += 4) { a[i] = Math.min(255, Math.pow(a[i] / 255, inv) * 255); a[i + 1] = Math.min(255, Math.pow(a[i + 1] / 255, inv) * 255); a[i + 2] = Math.min(255, Math.pow(a[i + 2] / 255, inv) * 255); }
        o.putImageData(d, 0, 0);
      } catch (e) { /* tainted canvas without CORS: draw ungraded */ }
      return c;
    }
    var off = null;
    var front = 'a', first = true, seq = 0;
    function draw(target) {
      var my = ++seq;
      var lens = st.lens, subj = st.subject, a = st.dist, zoom = ZOOMS[st.zi];
      return Promise.all([load(PLATE[lens]), load(SUBJ[subj])]).then(function (r) {
        if (my !== seq) return false;
        var plate = r[0], j = r[1];
        if (!off) { off = document.createElement('canvas'); off.width = Re; off.height = Re; }
        var k = off.getContext('2d');
        k.imageSmoothingEnabled = false; k.clearRect(0, 0, Re, Re); k.globalAlpha = 1; k.drawImage(plate, 0, 0, Re, Re);
        var t = Math.tan(FOV[lens] * Math.PI / 180 / 2), S = HEIGHT[subj];
        var T = Math.max(1, Math.round(S / a / (2 * t) * Re));
        var U = Math.max(1, Math.round(j.naturalWidth * T / j.naturalHeight));
        var L = JN / a / (2 * t) * Re;
        var D = a === 600 ? FLOOR[lens] : Math.round(KN + L);
        var C = Math.round(Re / 2 - U / 2), V = D - T;
        k.globalAlpha = Math.max(0.45, 1 - a / 1100);
        if (subj === 'truck') k.drawImage(gamma(j, U, T, 0.8), C, V, U, T); else k.drawImage(j, C, V, U, T);
        k.globalAlpha = 1;
        var H = Math.round(Re / zoom), O = Math.round((Re - H) / 2);
        var b = target.getContext('2d');
        b.imageSmoothingEnabled = false; b.clearRect(0, 0, Re, Re); b.globalAlpha = 1; b.drawImage(off, O, O, H, H, 0, 0, Re, Re);
        return true;
      });
    }
    function show(which) {
      front = which;
      canvA.classList.toggle('opacity-100', which === 'a'); canvA.classList.toggle('opacity-0', which !== 'a');
      canvB.classList.toggle('opacity-100', which === 'b'); canvB.classList.toggle('opacity-0', which !== 'b');
      if (frame) frame.style.opacity = '0';
    }
    function rescene() {
      var back = front === 'a' ? 'b' : 'a';
      var target = back === 'a' ? canvA : canvB;
      draw(target).then(function (ok) { if (ok) show(back); }).catch(function (e) { if (window.console) console.warn('[no-predator] range sim', e); });
    }
    function rezoom() { draw(front === 'a' ? canvA : canvB).catch(function () {}); }
    function renderUi() {
      lensBtns.forEach(function (b) { var on = b.getAttribute('data-no-val') === st.lens; swapCls(b, on ? SEL_OFF : SEL_ON, on ? SEL_ON : SEL_OFF); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      subjBtns.forEach(function (b) { var on = b.getAttribute('data-no-val') === st.subject; swapCls(b, on ? SEL_OFF : SEL_ON, on ? SEL_ON : SEL_OFF); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var y = DIST.indexOf(st.dist), pct = y / (DIST.length - 1) * 100;
      if (slider) { slider.value = String(y); slider.style.background = 'linear-gradient(to right, #10B981 0%, #10B981 ' + pct + '%, rgba(255,255,255,0.15) ' + pct + '%, rgba(255,255,255,0.15) 100%)'; }
      ticks.forEach(function (t) { t.classList.toggle('text-accent', Number(t.getAttribute('data-no-val')) === st.dist); });
      var z = ZOOMS[st.zi];
      if (zoomLabel) zoomLabel.textContent = z.toFixed(1) + 'X';
      if (hud.lens) hud.lens.textContent = LENS_LABEL[st.lens];
      if (hud.subject) hud.subject.textContent = SUBJ_LABEL[st.subject];
      if (hud.dist) hud.dist.textContent = st.dist + 'M';
      if (hud.zoom) hud.zoom.textContent = z.toFixed(1) + 'X';
    }
    lensBtns.forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-no-val'); if (v === st.lens) return; st.lens = v; renderUi(); rescene(); }); });
    subjBtns.forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-no-val'); if (v === st.subject) return; st.subject = v; renderUi(); rescene(); }); });
    if (slider) slider.addEventListener('input', function () { var d = DIST[parseInt(slider.value, 10)] || DIST[0]; if (d === st.dist) return; st.dist = d; renderUi(); rescene(); });
    zoomBtns.forEach(function (b) { b.addEventListener('click', function () { var dz = Number(b.getAttribute('data-no-val')); var zi = Math.max(0, Math.min(ZOOMS.length - 1, st.zi + dz)); if (zi === st.zi) return; st.zi = zi; renderUi(); rezoom(); }); });
    function setLens(v) { if (v !== '4_8' && v !== '13') return; if (v === st.lens) return; st.lens = v; renderUi(); rescene(); }
    renderUi();
    var started = false;
    function start() { if (started) return; started = true; draw(canvA).then(function (ok) { if (ok) show('a'); }).catch(function () {}); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); start(); } }, { rootMargin: '400px 0px' });
      io.observe(box);
    } else start();
    return { setLens: setLens, state: function () { return st; }, start: start };
  }());
  hooks('sim-lens').forEach(function (b) {
    b.addEventListener('click', function () {
      if (RS) { RS.start(); RS.setLens(b.getAttribute('data-no-val')); }
      var r = document.getElementById('range-sim'); if (r) r.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ---------------------------------------------------------------- 12. section 15: VIEW FULL SPECS */
  var specs = hook('specs-toggle');
  if (specs) {
    var specGroups = hooks('specs-group'), specFade = hook('specs-fade');
    var specsOpen = false;
    specs.addEventListener('click', function () {
      specsOpen = !specsOpen;
      specGroups.forEach(function (g) { if (g.getAttribute('data-no-val') !== '0') g.hidden = !specsOpen; });
      if (specFade) specFade.hidden = specsOpen;
      specs.setAttribute('aria-expanded', specsOpen ? 'true' : 'false');
      specs.textContent = specsOpen ? 'HIDE FULL SPECS' : 'VIEW FULL SPECS';
    });
  }

  /* ---------------------------------------------------------------- 13. section 11: tier rows + sticky MARKUP CHAIN */
  var chain = hook('s11-chain');
  if (chain) {
    var sticky11 = hook('s11-sticky'), rows11 = hooks('s11-row'), price11 = hook('s11-price'), no11 = hook('s11-no'), noRows11 = hooks('s11-no-row');
    var ADDS = [520, 640, 780, 610], BASE_PRICE = 850;
    var ROW_ON = 'opacity-100 translate-y-0', ROW_OFF = 'opacity-0 -translate-y-4';
    var lastN = -1;
    function chainFrame() {
      var x = chain.getBoundingClientRect(), v = window.innerHeight;
      var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
      var w = 0;
      if (mobile && sticky11) {
        var prev = chain.previousElementSibling, S = prev ? prev.getBoundingClientRect() : null;
        var annB = ann && !ann.hidden ? ann.getBoundingClientRect().bottom : 0;
        if (S) w = Math.max(0, (x.top - S.top) + annB + 36);
        sticky11.style.top = w + 'px';
      } else if (sticky11) sticky11.style.top = 'var(--no-sticky-top, 0px)';
      var j = x.height - v;
      var n = reducedMotion || j <= 0 ? 1 : Math.min(1, Math.max(0, (w - x.top) / j));
      if (Math.abs(n - lastN) < 0.0005) return;
      lastN = n;
      var o = Math.min(ADDS.length, Math.floor(n / 0.17)), i = Math.min(1, Math.max(0, n / 0.17 - o));
      var l = 0; for (var q = 0; q < o; q++) l += ADDS[q];
      if (o < ADDS.length) l += ADDS[o] * i;
      var c = Math.round(BASE_PRICE + l), d = n >= 0.72, p = n >= 0.78;
      rows11.forEach(function (r, idx) {
        if (idx === 0) return;
        var A = idx - 1, on = A < o || (A === o && i > 0.15);
        swapCls(r, on ? ROW_OFF : ROW_ON, on ? ROW_ON : ROW_OFF);
      });
      if (price11) price11.textContent = d ? '$2,800 TO $3,400' : '$' + c.toLocaleString('en-US');
      if (no11) { no11.classList.toggle('opacity-100', p); no11.classList.toggle('opacity-0', !p); }
      noRows11.forEach(function (r) { swapCls(r, p ? ROW_OFF : ROW_ON, p ? ROW_ON : ROW_OFF); });
    }
    scrollFns.push(chainFrame);
    chainFrame();
  }

  /* ---------------------------------------------------------------- 14. IN THE BOX (16) + BUY BOX (20): kit mirrors, bridge claim */
  var S16_ON = 'border-accent bg-accent text-accent-foreground';
  var S16_OFF = 'border-border-bright bg-background text-foreground hover:border-accent/60';
  var BUY_ON = 'border-accent bg-accent/10';
  var BUY_OFF = 'border-border-bright bg-background hover:border-accent/60';
  var CHK_ON = 'bg-accent border-accent text-accent-foreground';
  var CHK_OFF = 'border-border-bright';
  var TIER_TEXT = {
    core: { eyebrow: 'LAUNCH OFFER · FREE DUAL DOVETAIL BRIDGE · $179.95 VALUE', body: 'The bridge is a free launch gift for early bird orders. Not an upsell, not a later purchase: a real $179.95 accessory, included at no charge. Name-brand dual bridges run about $599 on their own. Ours ships free with the entry kit, so the day you want your PVS-14 riding beside the PREDATOR, thermal in one eye and analog in the other, the hardware is already yours. After launch it sells separately at $179.95.' },
    headworn: { eyebrow: 'HELMET AND RIFLE READY', body: 'Everything in CORE, plus both halves of the mount stack. The aluminum G24 clamps to a helmet shroud. The 90 degree flip-to-side QD puts the same optic on a 1913 rail and swings it clear of your eye or your day optic without unmounting anything. Centreline on the flip-to-side plate sits at approx. 43 mm (1.69 in). Built from CORE with both mounts added on, the same setup comes to $1,029.85. MOUNT KIT is $949.95: you save $79.90.' },
    loadout: { eyebrow: 'ADD REACH', body: 'One addition, and it is the one that changes what the same sensor can resolve. The 4mm wide sees approx. 42 degrees for scanning close terrain. The 13mm narrows to 13.5 degrees and pushes person detection to 250 meters, vehicle detection to 600. Both thread onto the same body by hand.' }
  };
  var PRICES = { core: 749.95, lens13: 199.95, g24: 99.95, flip: 179.95, headworn: 949.95, loadout: 1049.95 };
  var Ot = { left: 37.0833, top: 69.308, width: 31.3333, height: 20.7589 };
  var Ah = { x: 52.646, y: 79.66 };
  var lastClick = null;
  function notePoint(e) {
    if (e && 'clientX' in e && (e.clientX || e.clientY)) { lastClick = { x: e.clientX, y: e.clientY }; return; }
    var t = e && e.currentTarget ? e.currentTarget.getBoundingClientRect() : null;
    lastClick = t ? { x: t.left + t.width / 2, y: t.top + t.height / 2 } : null;
  }

  function renderS16Tabs(tier) {
    hooks('s16-tab').forEach(function (b) {
      var on = b.getAttribute('data-no-val') === tier;
      swapCls(b, on ? S16_OFF : S16_ON, on ? S16_ON : S16_OFF);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var tt = hook('s16-tier-text');
    if (tt && TIER_TEXT[tier]) {
      var eyebrow = tt.querySelector('div'), body = tt.querySelector('p');
      if (eyebrow) { var inner = eyebrow.querySelector('span'); (inner || eyebrow).textContent = TIER_TEXT[tier].eyebrow; }
      if (body) body.textContent = TIER_TEXT[tier].body;
    }
  }
  function renderAddonRows(prefix, s) {
    hooks(prefix + '-addon').forEach(function (row) {
      var key = row.getAttribute('data-no-val');
      var on = !!s[key], inc = !!s.included[key];
      var chk = $('[data-no="addon-check"]', row), price = $('[data-no="addon-price"]', row);
      if (chk) { rmCls(chk, CHK_ON + ' ' + CHK_OFF); addCls(chk, on ? CHK_ON : CHK_OFF); chk.innerHTML = on ? CHECK_SVG : ''; }
      if (price) price.textContent = inc ? 'INCLUDED' : kit.fmt(kit.ADDON_PRICE[key]);
      row.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  // the sprite hotspots in the flat lay
  var spriteLit = {};
  function renderSprites(s) {
    var lit = { g24: !!s.g24, flip: !!s.flip, lens13: !!s.lens13 };
    hooks('s16-sprite').forEach(function (b) {
      var key = b.getAttribute('data-no-val'), on = lit[key];
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', (on ? 'Remove the ' : 'Add the ') + (b.querySelector('[role="img"]') ? b.querySelector('[role="img"]').getAttribute('aria-label') : key));
      if (on && spriteLit[key] === false && !reducedMotion) {
        var scan = el('span', 'sprite-scan absolute inset-x-0 top-0 h-[38%] pointer-events-none'); scan.setAttribute('aria-hidden', 'true');
        b.appendChild(scan); setTimeout(function () { if (scan.parentNode) scan.parentNode.removeChild(scan); }, 650);
      }
      spriteLit[key] = on;
    });
    hooks('s16-sprite-wrap').forEach(function (w) { var on = lit[w.getAttribute('data-no-val')]; w.classList.toggle('opacity-100', on); w.classList.toggle('opacity-25', !on); });
    var colLit = { core: true, headworn: lit.g24 && lit.flip, loadout: lit.lens13 };
    hooks('s16-col-bar').forEach(function (bar) { var on = colLit[bar.getAttribute('data-no-val')]; bar.classList.toggle('bg-accent', on); bar.classList.toggle('bg-transparent', !on); });
    hooks('s16-col-title').forEach(function (t) { var on = colLit[t.getAttribute('data-no-val')]; t.classList.toggle('text-accent', on); t.classList.toggle('text-muted-foreground', !on); });
    hooks('s16-col-note').forEach(function (n) { var id = n.getAttribute('data-no-val'), on = colLit[id]; n.textContent = on ? (id === 'core' ? 'In every kit' : 'Adds') : 'Tap an item to add it'; });
  }
  // "That build comes to ..." (the Lovable _b hint), CORE tier only
  function buildHint(s) {
    if (s.tier !== 'core') return null;
    var t = s.lens13, n = s.g24, r = s.flip, l, tier, name, p, m;
    if (t && r) { l = PRICES.core + PRICES.lens13 + PRICES.flip; tier = 'loadout'; name = 'FULL LOADOUT'; p = PRICES.loadout; m = 'is ' + money(p) + ' and adds the G24 on top. You save ' + money(Math.round((l - p) * 100) / 100) + '.'; }
    else if (t && n) { l = PRICES.core + PRICES.lens13 + PRICES.g24; tier = 'loadout'; name = 'FULL LOADOUT'; p = PRICES.loadout; m = 'is ' + money(p) + ' and adds the flip-to-side QD mount.'; }
    else return null;
    return { total: Math.round(l * 100) / 100, tier: tier, name: name, m: m };
  }
  function renderBuild(hookName, s) {
    var pEl = hook(hookName);
    if (!pEl) return;
    var h = buildHint(s);
    if (!h) { pEl.hidden = true; pEl.innerHTML = ''; return; }
    pEl.hidden = false;
    pEl.innerHTML = '';
    pEl.appendChild(document.createTextNode('That build comes to ' + money(h.total) + '. '));
    var b = el('button', 'text-accent underline underline-offset-2'); b.type = 'button'; b.textContent = h.name;
    b.addEventListener('click', function () { kit.select(h.tier); });
    pEl.appendChild(b);
    pEl.appendChild(document.createTextNode(' ' + h.m));
  }
  function kbHtml(align) {
    return '<div class="flex items-center gap-2 mb-2 ' + (align === 'right' ? 'lg:justify-end' : 'justify-between') + '"><span class="flex items-center gap-2 mono text-[11px] tracking-[0.12em] uppercase text-muted-foreground">' + DOT + 'DUAL DOVETAIL BRIDGE (FREE, EARLY BIRD)</span><span class="mono text-[11px] tracking-[0.12em] uppercase"><span class="text-muted-foreground line-through">$179.95</span> <span class="text-accent">$0.00</span></span></div>';
  }

  // ---- bridge claim controls
  var claimOriginals = [];
  hooks('claim-free').forEach(function (b) { claimOriginals.push({ el: b, html: b.innerHTML, cls: b.className }); });
  hooks('claim-right').forEach(function (r) {
    var span = el('span', 'flex items-center gap-2 bridge-claim-in');
    span.innerHTML = DOT + '<span class="mono text-[11px] tracking-[0.14em] uppercase text-accent">CLAIMED · FREE · <span class="line-through">$179.95</span> VALUE</span>';
    span.hidden = true;
    span.setAttribute('data-no', 'claim-claimed');
    r.appendChild(span);
  });
  var wasClaimed = null;
  function renderClaims(s) {
    var claimed = !!s.bridge;
    root.setAttribute('data-no-claimed', claimed ? '1' : '0');
    claimOriginals.forEach(function (o) {
      var b = o.el, val = b.getAttribute('data-no-val') || '';
      if (val === 'pill') {
        if (claimed) {
          b.className = 'bridge-claim-in absolute -top-3 left-1/2 -translate-x-1/2 z-[5] inline-flex items-center gap-1.5 px-3 py-[5px] mono text-[9px] tracking-[0.18em] uppercase border border-accent bg-black text-accent whitespace-nowrap cursor-pointer';
          b.innerHTML = CHECK_SVG.replace('w-3 h-3', 'w-3 h-3 shrink-0') + 'BRIDGE CLAIMED';
          b.setAttribute('aria-label', 'Unclaim the free dual dovetail bridge');
        } else { b.className = o.cls; b.innerHTML = o.html; b.setAttribute('aria-label', 'Claim the free dual dovetail bridge'); }
        b.setAttribute('aria-pressed', claimed ? 'true' : 'false');
      } else if (val === 's16-au') {
        swapCls(b, claimed ? 'bridge-claim-pulse bg-transparent text-accent hover:bg-accent/10' : 'bridge-claim-in bg-accent text-accent-foreground', claimed ? 'bridge-claim-in bg-accent text-accent-foreground' : 'bridge-claim-pulse bg-transparent text-accent hover:bg-accent/10');
        b.innerHTML = claimed ? CHECK_SVG + 'CLAIMED' : 'CLAIM FREE';
        b.setAttribute('aria-pressed', claimed ? 'true' : 'false');
      } else {
        b.hidden = claimed; // the CLAIM FREE · $179.95 VALUE row button
      }
    });
    hooks('claim-claimed').forEach(function (sp) { sp.hidden = !claimed; });
    hooks('claim-badge').forEach(function (sp) { sp.hidden = claimed; });
    hooks('claim-toggle').forEach(function (b) {
      rmCls(b, CHK_ON + ' border-accent'); addCls(b, claimed ? CHK_ON : 'border-accent');
      b.innerHTML = claimed ? CHECK_SVG : '';
      b.setAttribute('aria-pressed', claimed ? 'true' : 'false');
      b.setAttribute('aria-label', (claimed ? 'Unclaim' : 'Claim') + ' the free dual dovetail bridge');
    });
    var kb16 = hook('s16-kb'), kb20 = hook('buy-kb');
    if (kb16) kb16.innerHTML = claimed ? kbHtml('right') : '';
    if (kb20) kb20.innerHTML = claimed ? kbHtml('between') : '';
    // the section 20 card animation
    var justClaimed = claimed && wasClaimed === false;
    hooks('buy-img').forEach(function (wrap, idx) {
      var cover = $('[data-no="buy-cover"]', wrap);
      var dot = $('[data-no="buy-dot"]', wrap);
      var A = idx * 90;
      if (!claimed) {
        if (cover) { cover.hidden = false; cover.classList.remove('bridge-cover-wipe'); cover.style.animationDelay = ''; cover.innerHTML = ''; }
        if (dot) dot.parentNode.removeChild(dot);
        $$('[data-no="buy-flash"]', wrap).forEach(function (f) { f.parentNode.removeChild(f); });
        return;
      }
      if (!dot) {
        dot = el('span', 'bridge-dot-in absolute block rounded-full bg-accent w-[7px] h-[7px]', 'left:' + Ah.x + '%;top:' + Ah.y + '%;transform:translate(-50%,-50%);box-shadow:0 0 6px hsl(var(--accent) / 0.9);z-index:3;animation-delay:' + (justClaimed && !reducedMotion ? (A + 420) : 0) + 'ms');
        dot.setAttribute('aria-label', 'Dual dovetail bridge included free');
        dot.setAttribute('data-no', 'buy-dot');
        wrap.appendChild(dot);
      }
      if (!cover) return;
      if (!justClaimed || reducedMotion) { cover.hidden = true; return; }
      cover.hidden = false;
      cover.classList.add('bridge-cover-wipe');
      cover.style.animationDelay = A + 'ms';
      cover.innerHTML = '<span class="bridge-wipe-edge absolute top-0 h-full w-[2px] bg-accent" style="animation-delay:' + A + 'ms;box-shadow:0 0 8px hsl(var(--accent) / 0.9)"></span>';
      var flash = el('span', 'bridge-glow-flash absolute pointer-events-none', 'left:' + Ot.left + '%;top:' + Ot.top + '%;width:' + Ot.width + '%;height:' + Ot.height + '%;z-index:3;animation-delay:' + A + 'ms');
      flash.setAttribute('data-no', 'buy-flash');
      wrap.appendChild(flash);
      setTimeout(function () { cover.hidden = true; cover.classList.remove('bridge-cover-wipe'); cover.innerHTML = ''; if (flash.parentNode) flash.parentNode.removeChild(flash); }, A + 700);
      // the flying dot from the press to the bridge
      var w = wrap.getBoundingClientRect();
      if (lastClick && w.bottom > 0 && w.top < window.innerHeight) {
        var to = { x: w.left + w.width * (Ot.left + Ot.width / 2) / 100, y: w.top + w.height * (Ot.top + Ot.height / 2) / 100 };
        var fly = el('span', '', 'position:fixed;left:0;top:0;width:8px;height:8px;border-radius:50%;background:hsl(var(--accent));pointer-events:none;z-index:9999;box-shadow:0 0 10px hsl(var(--accent) / 0.9);transition:transform 380ms ease-out;transform:translate(' + (lastClick.x - 4) + 'px,' + (lastClick.y - 4) + 'px)');
        root.appendChild(fly);
        requestAnimationFrame(function () { requestAnimationFrame(function () { fly.style.transform = 'translate(' + (to.x - 4) + 'px,' + (to.y - 4) + 'px)'; }); });
        setTimeout(function () { if (fly.parentNode) fly.parentNode.removeChild(fly); }, A + 420);
      }
    });
    wasClaimed = claimed;
  }

  /* ---------------------------------------------------------------- 15. DropLock pills next to every CTA */
  var LOCK_PILL = '<div aria-disabled="true" data-no="lock-pill" class="inline-flex select-none items-center justify-center gap-2 px-4 py-2 border border-accent/50 bg-black/70 text-accent mono text-[11px] font-bold tracking-[0.14em] uppercase cursor-not-allowed flex-1 py-3">' +
    '<svg class="lucide lucide-lock w-[13px] h-[13px]" fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><rect height="11" rx="2" ry="2" width="18" x="3" y="11"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>' +
    '<span class="tabular-nums" data-no="lock-clock">00:00:00:00</span></div>';
  var lockPills = [];
  function lockable(e) {
    if (!e || e.hasAttribute('data-no-lockable')) return;
    e.setAttribute('data-no-lockable', '1');
    var wrap = document.createElement('span');
    wrap.innerHTML = LOCK_PILL;
    var pill = wrap.firstChild;
    pill.hidden = true;
    e.parentNode.insertBefore(pill, e.nextSibling);
    lockPills.push({ el: e, pill: pill });
  }
  hooks('cta-kit').forEach(lockable);
  hooks('buy-cta').forEach(lockable);
  hooks('s16-cta').forEach(lockable);
  hooks('cta-add-13mm').forEach(lockable);
  function renderLock(locked) {
    lockPills.forEach(function (p) { p.el.hidden = locked; p.pill.hidden = !locked; });
  }

  /* ---------------------------------------------------------------- 16. bind to the kit engine */
  whenKit(function (k) {
    hooks('s16-tab').forEach(function (b) { b.addEventListener('click', function () { k.select(b.getAttribute('data-no-val')); }); });
    hooks('buy-tier').forEach(function (b) { b.addEventListener('click', function () { k.select(b.getAttribute('data-no-val')); }); });
    hooks('s11-tier').forEach(function (b) { b.addEventListener('click', function () { k.select(b.getAttribute('data-no-val')); var s16 = document.getElementById('sec-16'); if (s16) s16.scrollIntoView({ behavior: 'smooth', block: 'start' }); }); });
    ['s16', 'buy'].forEach(function (prefix) {
      hooks(prefix + '-addon').forEach(function (row) {
        row.addEventListener('click', function () { k.toggle(row.getAttribute('data-no-val')); });
      });
      hooks(prefix + '-cta').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); k.addToCart(b); });
      });
    });
    hooks('s16-sprite').forEach(function (b) { b.addEventListener('click', function () { k.toggle(b.getAttribute('data-no-val')); }); });
    hooks('claim-free').forEach(function (b) {
      var val = b.getAttribute('data-no-val') || '';
      var handler = function (e) {
        e.preventDefault(); e.stopPropagation(); notePoint(e);
        if (val === 'pill' || val === 's16-au') k.toggleBridge(); else k.setBridge(true);
      };
      b.addEventListener('click', handler);
      if (b.tagName === 'SPAN') b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') handler(e); });
    });
    hooks('claim-toggle').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); notePoint(e); k.toggleBridge(); }); });
    var add13 = hook('cta-add-13mm');
    if (add13) add13.addEventListener('click', function () { k.set('lens13', true); var kb = document.getElementById('no-predator-kit'); if (kb) kb.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    var selLoad = hook('cta-select-loadout');
    if (selLoad) selLoad.addEventListener('click', function () { k.select('loadout'); var kb = document.getElementById('no-predator-kit'); if (kb) kb.scrollIntoView({ behavior: 'smooth', block: 'start' }); });

    k.subscribe(function (s) {
      renderS16Tabs(s.tier);
      hooks('buy-tier').forEach(function (b) {
        var on = b.getAttribute('data-no-val') === s.tier;
        rmCls(b, BUY_ON + ' ' + BUY_OFF); addCls(b, on ? BUY_ON : BUY_OFF);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      renderAddonRows('s16', s);
      renderAddonRows('buy', s);
      renderSprites(s);
      hooks('s16-total').forEach(function (t) { t.textContent = k.fmt(s.price); });
      hooks('buy-total').forEach(function (t) { t.textContent = k.fmt(s.price); });
      var sez = hook('buy-sezzle');
      if (sez) sez.textContent = 'or 4 interest-free payments of $' + (s.price / 4).toFixed(2) + ' over 6 weeks with Sezzle';
      renderBuild('s16-build', s);
      renderBuild('buy-build', s);
      renderLock(s.locked);
      renderClaims(s);
    });
    k.onTick(function (ms) {
      if (ms <= 0) return;
      var c = k.clock(ms);
      $$('[data-no="lock-clock"]').forEach(function (e) { e.textContent = c; });
    });
  });
}());
